const state = {
  paxToAsingar: []
}
const getters = {
  getPaxToAsingar: (state, getters, rootState) => {
    return state.paxToAsingar
  }
}
const actions = {
  guardarPaxToAsignar({ commit, state, dispatch }, item) {
    commit("eliminarFormPaxToAsignar", item.belong)
    commit("setPaxToAsignar", item)
  },
  limpiarPaxToAsingar({ commit, state, dispatch }, item) {
    const indice = state.paxToAsingar.indexOf(p => (p.belong = item))
    commit("limpiarPaxToAsingar", item)
  },
  eliminarFormPaxToAsignar({ commit, state, dispatch }, item) {
    commit("eliminarFormPaxToAsignar", item)
  }
}
const mutations = {
  setPaxToAsignar(state, item) {
    state.paxToAsingar = state.paxToAsingar.concat(item)
  },
  eliminarFormPaxToAsignar(state, belong) {
    state.paxToAsingar = state.paxToAsingar.filter(p => p.belong != belong)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
